import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { UserService } from 'src/app/_service/user.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from 'src/app/_models/user';
import { MAT_DIALOG_DATA } from '@angular/material';
import { TreeComponent } from 'src/app/tree/tree.component';
import { AuthService } from 'src/app/_service/auth.service';

@Component({
  selector: 'showUserLocation',
  templateUrl: './showUserLocation.component.html',
  styleUrls: ['./showUserLocation.component.css']
})
export class ShowUserLocationComponent implements OnInit {

  constructor(private userService: UserService,
    private alertify: AlertifyService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    ) { }

    @ViewChild(TreeComponent, { static: true }) locationTree: TreeComponent;

    userOutsideId = this.passedData.user;

  locations: any;
  authorityUnitId: any;
  confirmModal = false;
  deleteLocationID: any;
  singleLocationRemaining = false;
  singleLocationRestriction: any = {};

  sdsUserId: any;
  sdsUserIdNumber: number;

  usersInLocation: boolean;
  timeForLocation: any;
  checkedNodes: any = null;
  updateLocModel: any = {};


  model: any = {};

  user = {
    emailAddress: '',
      firstName: '',
      lastName: '',
      addressLine1: '',
      addressLine2: '',
      country: '',
      city: '',
      province: '',
      faxNumber: '',
      phoneNumber: '',
      postalCode: '',
      userOutsideId: ''
  };

  ngOnInit() {
    this.loadUser();
    this.loadLocations();
       // get userid for location tree (for site admins)
       this.sdsUserId = this.authService.decodedToken.userid;
       this.sdsUserIdNumber = +this.sdsUserId;
  }

  getLocationTree() {
    if (this.locationTree.location.length === 0) { return; }
    this.checkedNodes = [];
    console.log(this.locationTree.location);
    for (const node of this.locationTree.location) {
      this.markLocations(node, 0);
    }
    clearInterval(this.timeForLocation);
    this.locationTree.checklistSelection.select(...this.checkedNodes);
    console.log(this.locationTree.checklistSelection.selected);
  }

  markLocations(node: any, level: number) {
    if (this.locations[0].locationId.indexOf(node.authorityUnitId) > -1) {
      const flat = this.locationTree.transformer(node, level);
      this.locationTree.treeControl.expand(flat);
      this.checkedNodes.push(flat);
    }
    if (node.children != null && node.children.length > 0) {
      for (const chd of node.children) {
        this.markLocations(chd, level + 1);
      }
    }
  }

  loadLocations() {
    return this.userService.getUserLocation(this.userOutsideId).subscribe(
      res => {
        this.locations = res;
        this.timeForLocation = setInterval(() => { this.getLocationTree(); }, 10);
        // console.log('This: ' + this.locations.locationName);
        // for (const test of this.locations) {
          if (this.locations.length > 0) {
            this.usersInLocation = true;
          } else {
            this.usersInLocation = false;
          }
          // console.log(test.locationName);
        // }
    });
  }

  loadUser() {
    this.userService.getUser(this.userOutsideId).subscribe((user: User) => {
      this.user = user;
      console.log('users: ' + this.user);
    },
    error => {
      this.alertify.error('Unable to load user');
    });
  }

  removeSelectedLocation(authorityUnitId) {
    this.confirmModal = true;
    this.deleteLocationID = authorityUnitId;
  }

  dontDeleteLocation() {
    this.confirmModal = false;
  }


  updateLocations() {
    if (this.authService.decodedToken.role === 'Site Admin') {
      this.updateLocModel.LocationId = [];
      for (const loc of this.locationTree.checklistSelection.selected) {
        if (loc.userId === this.sdsUserIdNumber) {
          this.updateLocModel.LocationId.push(loc.authorityUnitId);
        }
      }
    }
    if (this.authService.decodedToken.role === 'Super Admin') {
      this.updateLocModel.LocationId = [];
      for (const loc of this.locationTree.checklistSelection.selected) {
        this.updateLocModel.LocationId.push(loc.authorityUnitId);
      }
    }

    return this.userService.updateUserLocations(this.userOutsideId , this.updateLocModel).subscribe(res => {
      this.alertify.success('Location has been updated successfully');
    }, error => {
        this.alertify.error('Something went wrong, please try again');
      });

  }
//   removeUserLocations(authorityUnitId) {
//     // this.singleLocationRemaining = true;
//     this.model.authorityUnitId = authorityUnitId;
//     this.model.userOutSideId = this.userOutsideId;
//     return this.userService.removeUserLocation(this.model).subscribe(
//       res => {
//         this.singleLocationRestriction = res.headers.get('singlelocation');
//         if (this.singleLocationRestriction) {
//           this.singleLocationRemaining = true;
//           // this.loadLocations();
//           this.alertify.success(this.singleLocationRestriction);
//         } else {
//           this.loadLocations();
//           this.alertify.success('Location successfully removed');
//           this.confirmModal = false;
//           this.singleLocationRemaining = false;
//         }
//     }, error => {
//       this.alertify.error('Something went wrong, please try again');
//     });
// }
}
